import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-gray-900 text-gray-400 py-12" data-id="element-13">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
          <div className="text-center space-y-4" data-id="element-15">
            <p className="text-sm" data-id="element-16">
              © {new Date().getFullYear()} Side Hustle Express. Todos los
              derechos reservados.
            </p>
            <p className="text-sm text-gray-500" data-id="element-17">
              Hecho con ❤️ para mujeres emprendedoras.
            </p>
            <div className="flex items-center justify-center gap-6 pt-4" data-id="element-18">
              <button onClick={() => setShowPrivacy(true)} className="text-sm text-gray-400 hover:text-white transition-colors underline" data-id="element-19">
                Privacy Policy
              </button>
              <span className="text-gray-600" data-id="element-20">•</span>
              <button onClick={() => setShowTerms(true)} className="text-sm text-gray-400 hover:text-white transition-colors underline" data-id="element-21">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacy && <Modal onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-22">
          <div className="space-y-4 text-gray-700" data-id="element-23">
            <p data-id="element-24">
              En Side Hustle Express, valoramos tu privacidad y nos
              comprometemos a proteger tu información personal.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-25">
              Información que Recopilamos
            </h3>
            <p data-id="element-26">
              Cuando compras nuestro producto, recopilamos información básica
              como tu nombre y correo electrónico para entregarte el PDF y
              enviarte actualizaciones importantes sobre tu compra.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-27">
              Uso de la Información
            </h3>
            <p data-id="element-28">Utilizamos tu información únicamente para:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-29">
              <li data-id="element-30">Procesar tu compra y entregarte el producto</li>
              <li data-id="element-31">Enviarte confirmaciones y recibos</li>
              <li data-id="element-32">Responder a tus preguntas o solicitudes de soporte</li>
              <li data-id="element-33">Mejorar nuestros productos y servicios</li>
            </ul>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-34">
              Protección de Datos
            </h3>
            <p data-id="element-35">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros para fines de marketing. Utilizamos medidas de seguridad
              estándar de la industria para proteger tu información.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-36">Cookies</h3>
            <p data-id="element-37">
              Nuestro sitio web puede utilizar cookies para mejorar tu
              experiencia de navegación. Puedes configurar tu navegador para
              rechazar cookies, aunque esto puede afectar algunas
              funcionalidades del sitio.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-38">Tus Derechos</h3>
            <p data-id="element-39">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal en cualquier momento. Si deseas ejercer estos derechos,
              contáctanos y responderemos a tu solicitud lo antes posible.
            </p>

            <p className="mt-6 text-sm text-gray-500" data-id="element-40">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
            </p>
          </div>
        </Modal>}

      {/* Terms of Service Modal */}
      {showTerms && <Modal onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-41">
          <div className="space-y-4 text-gray-700" data-id="element-42">
            <p data-id="element-43">
              Al comprar y utilizar Side Hustle Express para Mujeres, aceptas
              los siguientes términos y condiciones.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-44">
              Descripción del Producto
            </h3>
            <p data-id="element-45">
              Side Hustle Express es un producto digital (PDF) que proporciona
              un método paso a paso para lanzar un side hustle de servicios en
              30 días. El producto incluye plantillas, guiones y un tablero de
              trabajo.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-46">
              Entrega del Producto
            </h3>
            <p data-id="element-47">
              Una vez completado el pago, recibirás acceso inmediato al PDF por
              correo electrónico. Es tu responsabilidad proporcionar una
              dirección de correo electrónico válida y verificar tu bandeja de
              entrada (incluyendo spam).
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-48">
              Política de Reembolsos
            </h3>
            <p data-id="element-49">
              Debido a la naturaleza digital del producto y el acceso inmediato,
              no ofrecemos reembolsos una vez que has recibido el PDF. Te
              recomendamos leer cuidadosamente la descripción del producto antes
              de comprar.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-50">Uso del Producto</h3>
            <p data-id="element-51">El PDF es para tu uso personal únicamente. No está permitido:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-52">
              <li data-id="element-53">Compartir, revender o distribuir el contenido</li>
              <li data-id="element-54">Reclamar el contenido como propio</li>
              <li data-id="element-55">
                Utilizar el contenido para crear productos derivados sin
                autorización
              </li>
            </ul>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-56">
              Limitación de Responsabilidad
            </h3>
            <p data-id="element-57">
              Side Hustle Express proporciona información educativa y
              herramientas prácticas. No garantizamos resultados específicos, ya
              que el éxito depende de tu esfuerzo, dedicación y circunstancias
              individuales. No somos responsables de pérdidas o daños derivados
              del uso de este producto.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-58">
              Propiedad Intelectual
            </h3>
            <p data-id="element-59">
              Todo el contenido, incluyendo texto, gráficos, plantillas y
              diseño, es propiedad de Side Hustle Express y está protegido por
              leyes de derechos de autor.
            </p>

            <h3 className="font-bold text-gray-900 mt-6" data-id="element-60">Modificaciones</h3>
            <p data-id="element-61">
              Nos reservamos el derecho de actualizar estos términos en
              cualquier momento. Los cambios entrarán en vigor inmediatamente
              después de su publicación en esta página.
            </p>

            <p className="mt-6 text-sm text-gray-500" data-id="element-62">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
            </p>
          </div>
        </Modal>}
    </>;
}
function Modal({
  onClose,
  title,
  children
}: {
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-63">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden" data-id="element-64">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-65">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-66">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Cerrar" data-id="element-67">
            <X className="w-6 h-6 text-gray-500" data-id="element-68" />
          </button>
        </div>
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(90vh-80px)]" data-id="element-69">
          {children}
        </div>
      </div>
    </div>;
}